import Lottie from "react-lottie";
import lumoMainLoader from "assets/lotties/lumo-loader";
import { FullPageWrapper } from "./styles";

export const FullPageLoading = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lumoMainLoader,
  };

  return (
    <FullPageWrapper>
      <Lottie options={defaultOptions} height={88} width={180} />
    </FullPageWrapper>
  );
};
